// IconaFiltro.tsx — v027: l'icona disegnata di un filtro (web/public/filtri/icone/<id>.webp, 256 px, sfondo
// trasparente; ritagliate dai fogli del proprietario, vedi docs/filtri/LEGGIMI.md). Decorativa: il nome è accanto.
import { useState } from "react";

export function fileIconaFiltro(id: string): string {
  return `/filtri/icone/${id}.webp`;
}

export function IconaFiltro({ id, nome, dimensione = 64, classe = "" }: { id: string; nome: string; dimensione?: number; classe?: string }) {
  const [rotta, setRotta] = useState(false);
  if (rotta)
    return (
      <span className={`carta-filtro-segno ${classe}`} aria-hidden="true">
        {nome.slice(0, 1)}
      </span>
    );
  return (
    <img
      className={`ld-icona-filtro ${classe}`}
      src={fileIconaFiltro(id)}
      width={dimensione}
      height={dimensione}
      alt=""
      loading="lazy"
      decoding="async"
      draggable={false}
      onError={() => setRotta(true)}
    />
  );
}
